module.exports = __webpack_public_path__ + "static/media/catalogue-ru-preview.abf021ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/docs/catalogue-ru-preview.png
// module id = 727
// module chunks = 0